// *** Angular
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';

// *** Packages
import {
   ApexAxisChartSeries,
   ApexChart,
   ApexTitleSubtitle,
   ApexXAxis,
} from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';

// *** Services
import { AdministratorStatisticsService } from 'src/app/services/administrator-statistics.service';
import { LanguageService } from 'src/app/services/language.service';
import { TranslateService } from '@ngx-translate/core';

export type ChartOptions = {
   series: ApexAxisChartSeries;
   chart: ApexChart;
   xaxis: ApexXAxis;
   title: ApexTitleSubtitle;
   labels: string[];
};
@Component({
   selector: 'app-submissions-basic',
   templateUrl: './submissions-basic.component.html',
   styleUrls: ['./submissions-basic.component.scss'],
})
export class SubmissionsBasicComponent implements OnInit {
  currentLanguage: string = localStorage.getItem('websiteLanguage');
   /**
    * Variabel used to store data that are shown on chart
    */
   institutionSubmissionsData: any;
   /**
    * Variabel used to store options for chart
    */
   chartOptions = {
      series: [
         {
            name: this.translate.instant('report.high_similarity'),
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
             color: '#E21212'
         },
         {
            name: this.translate.instant('report.medium_similarity'),
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            color: '#F2A202'
         },
         {
            name: this.translate.instant('report.low_similarity'),
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            color: '#1BA76D'
         },
      ],
      colors: ['#E21212', '#F2A202', '#1BA76D'],
      chart: {
         height: 350,
         type: 'line',
         zoom: {
            enabled: true,
         },
      },
      dataLabels: {
         enabled: true,
         style: {
            colors: ['#F44336', '#E91E63', '#9C27B0'],
         },
      },
      title: {
         text: 'Educators',
         align: 'center',
      },
      xaxis: {
         categories: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
         ],
      },
      grid: {
         borderColor: '#f1f1f1',
      },
   };
   /**
    * Variabel used to store current year
    */
   year: number;
   lastFourYears: number[] = [];
   availableYears: number[] = [];
   constructor(
      private statistics: AdministratorStatisticsService,
      private spinner: NgxSpinnerService,
      private languageService: LanguageService,
      public translate: TranslateService
   ) {}

   ngOnInit(): void {
      this.languageService.selectedLanguage$.subscribe((language: string) => {
        this.currentLanguage = language;
        this.translate.use(language);
      });

      this.year = new Date().getFullYear();
      this.lastFourYears = Array.from({ length: 5 }, (_, index) => this.year - index);
      this.availableYears = this.lastFourYears.reverse();
      this.statistics
         .institutionSubmissionsStatisticsBasic(this.year)
         .pipe(first())
         .subscribe(
            (data) => {
               this.institutionSubmissionsData = data;
               console.log(
                  'this.institutionSubmissionsData',
                  this.institutionSubmissionsData
               );
               this.chartOptions = {
                  series: [
                     {
                        name: this.translate.instant('report.high_similarity'),
                        data: data.highSimilarity,
                        color: '#E21212'
                     },
                     {
                        name: this.translate.instant('report.medium_similarity'),
                        data: data.mediumSimilarity,
                        color: '#F2A202'
                     },
                     {
                        name: this.translate.instant('report.low_similarity'),
                        data: data.lowSimilarity,
                        color: '#1BA76D'
                     },
                  ],
                  colors: ['#F44336', '#E91E63', '#9C27B0'],
                  chart: {
                     height: 350,
                     type: 'line',
                     zoom: {
                        enabled: true,
                     },
                  },
                  dataLabels: {
                     enabled: true,
                     style: {
                        colors: ['#F44336', '#E91E63', '#9C27B0'],
                     },
                  },
                  title: {
                     text: 'Page Statistics',
                     align: 'left',
                  },
                  xaxis: {
                     categories: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                     ],
                  },
                  grid: {
                     borderColor: '#f1f1f1',
                  },
               };
            },
            (error) => {
               console.log('error', error);
            }
         );
   }
   /**
    * Function is used to filter statitistics by year
    * @param value
    */
   filterByYear(value) {
      this.spinner.show();

      this.year = parseInt(value);
      this.statistics
         .institutionSubmissionsStatisticsBasic(this.year)
         .pipe(first())
         .subscribe(
            (data) => {
               console.log('data', data);
               this.institutionSubmissionsData = data;
               this.chartOptions = {
                  series: [
                     {
                        name:this.translate.instant('report.high_similarity'),
                        data: this.institutionSubmissionsData.highSimilarity,
                        color: '#E21212'

                     },
                     {
                        name: this.translate.instant('report.medium_similarity'),
                        data: this.institutionSubmissionsData.mediumSimilarity,
                        color: '#F2A202'

                     },
                     {
                        name: this.translate.instant('report.low_similarity'),
                        data: this.institutionSubmissionsData.lowSimilarity,
                        color: '#1BA76D'

                     },
                  ],
                  colors: ['#E21212', '#F2A202', '#1BA76D'],
                  chart: {
                     height: 350,
                     type: 'line',
                     zoom: {
                        enabled: true,
                     },
                  },
                  dataLabels: {
                     enabled: true,
                     style: {
                        colors: ['#E21212', '#F2A202', '#1BA76D'],
                     },
                  },
                  title: {
                     text: 'Page Statistics',
                     align: 'left',
                  },
                  xaxis: {
                     categories: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                     ],
                  },
                  grid: {
                     borderColor: '#f1f1f1',
                  },
               };
               this.spinner.hide();
            },
            (error) => {
               this.spinner.hide();

               console.log('error', error);
            }
         );
   }
}
